// 라이더
export default {
    employee_type_option: {
        full_time: "근로계약(정규직포함)",
        special: "특수고용직",
        hub_owner: "사업주(허브장 본인)",
    },
    salary_type_option: {
        fixed_pay: "고정급(출금제한)",
        performance_pay: "실적급(자율출금)",
    },
    hub_name: "허브명",
    adjustment_date: "일시",
    employee_type: "고용형태",
    salary_type: "보수지급방식",
    hub_employee_number: "사번",
    worker_code: "라이더 코드",
    worker_name: "라이더명",
    worker_baromoney_closing_amount: "라이더 바로머니 마감금액",
    order_finish_count: "완료건수",
    delivery_adjust_amount: "배달대행료 금액",
    delivery_fee: "배달대행 수수료",
    worker_profit: "라이더 수익",
    worker_withholding_tax: "원천세",
    baromoney_adjust_amount_sum: "바로머니 정산 합계",
    pay_cash_amount: "현금상품액",
    company_deposit_amount: "회사입금액",
    start_worked_at: "출근",
    end_worked_at: "퇴근",
    total_delivery_count: "전체완료",
    working_time: "전체근무시간(분)",
    total_delivery_count_in_period: "시간범위완료",
    working_time_in_period: "시간범위근무시간(분)",
    sum: "합계",
    sum_working_time: "월근무시간",
    sum_working_count: "월근무일수",
    sum_delivery_count: "월완료건수",
    avg_working_minute: "일평균근무시간",
    avg_delivery_count: "일평균완료건수",
    avg_delivery_count_by_hour: "시간당완료건수",
    sum_working_minute_in_period: "시간범위근무시간",
    sum_delivery_count_in_period: "시간범위완료건수",
    avg_working_minute_in_period: "시간범위일평균근무시간",
    avg_delivery_count_in_period: "시간범위일평균완료건수",
    avg_delivery_count_in_period_hour: "시간범위시간당완료건수",
};
